package one.healthium.carnivore

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://carni-stage-content.web.app/"
                Flavour.Prod -> "https://carni-prod-content.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "CARNI",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> "f7253ec97d63cb060c069f5e63eda9a6"
            Flavour.Prod -> "384d8a7b7c60069cbecc5581207e7a0b"
        },
        adaptyKey = "public_live_3mNtQxLd.qeiRgO461x0XiJDezOfb",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6529544624",
        feedbackEmail = "hello@vividcarnivore.com",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:728987467420:android:e4d1376959def3ccd8f759",
                apiKey = "AIzaSyA9fiZm2dXTuegyPsogtXp30C0cNx_KWRI",
                projectId = "carnivore-app-stage",
                storageBucket = "carnivore-app-stage.appspot.com",
                userStorageBucket = "gs://carnivore-stage-users-data",
                authDomain = "carnivore-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:329872911490:android:7783d67c840b85cbbfd89b",
                apiKey = "AIzaSyCSciCTrfnBvAJOn2rgBFGBwZIFzxE18LY",
                projectId = "carnivore-app-prod",
                storageBucket = "carnivore-app-prod.appspot.com",
                userStorageBucket = "gs://carnivore-prod-users-data",
                authDomain = "carnivore-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "carni_stage"
            Flavour.Prod -> "carni"
        },
        oneLinkBaseUrl = "https://hltm-carni.onelink.me/Hetu/web",
    )

